import React from 'react';
import { CheckCircle2, UserPlus, QrCode, ScanLine, ArrowRight } from 'lucide-react';
export function FeatureRegistration() {
  return <section className="w-full border-b border-white/[0.06]" style={{
    backgroundColor: '#09090B'
  }} data-id="element-331">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28" data-id="element-332">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-333">
          {/* Text — Left */}
          <div data-id="element-334">
            <p className="text-xs uppercase tracking-wider font-mono text-blue-400" data-id="element-335">
              Inscription &amp; Identité
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-white mt-4 leading-tight font-heading" data-id="element-336">
              Chaque participant entre par un parcours structuré et brandé — et
              porte une identité digitale tout au long de l'événement.
            </h2>
            <div className="mt-8 space-y-5" data-id="element-337">
              <div className="flex items-start gap-3" data-id="element-338">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-339" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-340">
                  Formulaires d'inscription personnalisés avec niveaux d'accès
                  par rôle
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-341">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-342" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-343">
                  Badge digital auto-généré à la confirmation, disponible en PDF
                  imprimable
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-344">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-345" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-346">
                  QR code unique par participant pour le check-in et la capture
                  de leads exposants
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-347">
                <CheckCircle2 className="h-5 w-5 text-blue-400 mt-0.5 flex-shrink-0" data-id="element-348" />
                <p className="text-white/70 text-sm leading-relaxed" data-id="element-349">
                  Le scan de badge fonctionne sur n'importe quel smartphone —
                  aucun matériel requis
                </p>
              </div>
            </div>
          </div>

          {/* Visual — Right */}
          <div className="bg-white/[0.04] border border-white/[0.08] rounded-2xl p-8" data-id="element-350">
            <div className="space-y-6" data-id="element-351">
              {/* Step 1 */}
              <div className="flex items-center gap-4" data-id="element-352">
                <div className="bg-white/[0.06] rounded-lg p-4 flex items-center gap-3 flex-1" data-id="element-353">
                  <div className="w-10 h-10 rounded-lg bg-blue-500/20 flex items-center justify-center flex-shrink-0" data-id="element-354">
                    <UserPlus className="h-5 w-5 text-blue-400" data-id="element-355" />
                  </div>
                  <div data-id="element-356">
                    <p className="text-white/60 text-xs font-mono" data-id="element-357">
                      Inscription
                    </p>
                  </div>
                </div>
                <ArrowRight className="h-4 w-4 text-blue-400/60 flex-shrink-0" data-id="element-358" />
                <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg px-4 py-3 flex-shrink-0" data-id="element-359">
                  <p className="text-blue-400 text-xs font-mono" data-id="element-360">
                    Badge généré
                  </p>
                </div>
              </div>

              {/* Dashed connector */}
              <div className="border-l-2 border-dashed border-white/[0.10] h-4 ml-9" data-id="element-361" />

              {/* Step 2 */}
              <div className="flex items-center gap-4" data-id="element-362">
                <div className="bg-white/[0.06] rounded-lg p-4 flex items-center gap-3 flex-1" data-id="element-363">
                  <div className="w-10 h-10 rounded-lg bg-blue-500/20 flex items-center justify-center flex-shrink-0" data-id="element-364">
                    <QrCode className="h-5 w-5 text-blue-400" data-id="element-365" />
                  </div>
                  <div data-id="element-366">
                    <p className="text-white/60 text-xs font-mono" data-id="element-367">
                      Badge scanné
                    </p>
                  </div>
                </div>
                <ArrowRight className="h-4 w-4 text-blue-400/60 flex-shrink-0" data-id="element-368" />
                <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg px-4 py-3 flex-shrink-0" data-id="element-369">
                  <p className="text-blue-400 text-xs font-mono" data-id="element-370">
                    Check-in enregistré
                  </p>
                </div>
              </div>

              {/* Dashed connector */}
              <div className="border-l-2 border-dashed border-white/[0.10] h-4 ml-9" data-id="element-371" />

              {/* Step 3 */}
              <div className="flex items-center gap-4" data-id="element-372">
                <div className="bg-white/[0.06] rounded-lg p-4 flex items-center gap-3 flex-1" data-id="element-373">
                  <div className="w-10 h-10 rounded-lg bg-blue-500/20 flex items-center justify-center flex-shrink-0" data-id="element-374">
                    <ScanLine className="h-5 w-5 text-blue-400" data-id="element-375" />
                  </div>
                  <div data-id="element-376">
                    <p className="text-white/60 text-xs font-mono" data-id="element-377">
                      Exposant scanne
                    </p>
                  </div>
                </div>
                <ArrowRight className="h-4 w-4 text-blue-400/60 flex-shrink-0" data-id="element-378" />
                <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg px-4 py-3 flex-shrink-0" data-id="element-379">
                  <p className="text-blue-400 text-xs font-mono" data-id="element-380">
                    Lead capturé
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}